import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateQuebecMatrimonialRegimeType extends Enum {
  static PARTNERSHIP_OF_ACQUESTS = {
    key: 'partnership_of_acquests',
    get value() {
      return Lang.t('estate.partnership-of-acquests');
    }
  };

  static SEPARATE_AS_TO_PROPERTY = {
    key: 'separate_as_to_property',
    get value() {
      return Lang.t('estate.separate-to-property');
    }
  };

  static OTHER = {
    key: 'other',
    get value() {
      return Lang.t('asset.other');
    }
  };
}
